module.exports = __webpack_public_path__ + "static/media/attension.7025a8fd.svg";